import { useFieldArray } from 'react-hook-form';
import { RoleSettings } from 'assets/js/pages/account-settings/users/types';
import * as Form from 'components/form';
import * as Tooltip from 'components/tooltip/Tooltip';
import { ACCOUNT_MEMBER_ROLES_HELP } from 'constants/links';

const UserRoleFields = () => {
    const methods = Form.useGivebutterFormContext<RoleSettings>();
    const { control, path } = methods;

    const rolesFieldArray = useFieldArray({
        name: 'roles',
        control,
        rules: {
            validate: roles =>
                roles.map(role => role.checked).filter(checked => checked).length === 0
                    ? 'Please choose at least one role.'
                    : true,
        },
    });

    const { fields: roleFields } = rolesFieldArray;

    return (
        <div className="flex flex-col gap-4">
            <div>
                <p className="text-sm font-medium text-black">Select roles</p>
                <div className="flex">
                    <p className="max-w-md text-sm text-gray-600">
                        For more information on specific roles,{' '}
                        <a
                            target="_blank"
                            className="text-blue-500"
                            rel="noopener noreferrer"
                            href={ACCOUNT_MEMBER_ROLES_HELP}
                        >
                            read our guide.
                        </a>
                    </p>
                </div>
            </div>
            <div className="flex flex-col">
                <div className="flex max-w-lg flex-col gap-2">
                    <div className="flex flex-col gap-4">
                        {roleFields.map((field, index) => (
                            <div key={field.id} className="flex items-start gap-2">
                                <Tooltip.Root>
                                    <div className="relative flex h-5 items-center">
                                        <Form.UseFormCheckboxInput
                                            value={field.id}
                                            control={control}
                                            name={path(`roles.${index}.checked`)}
                                            checked={field.checked}
                                            disabled={!field.userCanAssign}
                                        />
                                        {!field.userCanAssign && (
                                            <Tooltip.Trigger asChild>
                                                <span className="absolute inset-0" />
                                            </Tooltip.Trigger>
                                        )}
                                    </div>
                                    <Tooltip.Portal>
                                        <Tooltip.Content inverse>
                                            <p>You cannot assign permissions you do not have.</p>
                                            <Tooltip.Arrow inverse />
                                        </Tooltip.Content>
                                    </Tooltip.Portal>
                                </Tooltip.Root>
                                <div className="flex flex-col gap-1">
                                    <Form.Label name={path(`roles.${index}.checked`)}>
                                        {field.name}
                                    </Form.Label>
                                    <div className="text-sm text-gray-500">{field.description}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <Form.Container>
                    <Form.Error name={path('roles')} />
                </Form.Container>
            </div>
        </div>
    );
};

export { UserRoleFields };
